module.exports = __webpack_public_path__ + "media/barrel-explosion.e090943a.mp3";